import React from 'react';

import MarketNavigation from './MarketNavigation/MarketNavigation';
import MarketHome from './MarketHome/MarketHome';
import MarketAbout from './MarketAbout/MarketAbout';
import MarketProjects from './MarketProjects/MarketProjects';

const MarketPage = () => {

    return (
        <>
            {/* <iframe title='Landtrack Marketplace' src="https://marketplace.landtrack.pk/" style={{ width: '100%', height: '100vh', border: 'none' }}></iframe> */}

            <MarketNavigation />
            <MarketHome />
            <MarketAbout />
            <MarketProjects />

        </>
    );
};

export default MarketPage;